const InternTnC = () => {
  return (
    <div className="p-6 bg-gray-50 text-gray-800 space-y-6">
      {/* Section Header */}
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">Terms & Conditions for Internship Applicants</h2>
        <p className="text-gray-600 text-sm">Please read the terms carefully before applying.</p>
      </div>

      {/* General Terms */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">1. General Terms</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>The internship is offered for a duration of <strong>6 months</strong>, extendable up to <strong>12 months</strong> based on performance.</li>
          <li>Each district in India is eligible for <strong>1 internship position</strong>, with the possibility of multiple interns based on requirements.</li>
          <li>Interns will <strong>work remotely</strong> using their own resources.</li>
        </ul>
      </div>

      {/* Compensation and Incentives */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">2. Compensation and Incentives</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>Monthly stipend of <strong>₹2000.00</strong>, provided they achieve the required sales targets during the internship period.</li>
          <li>An incentive of up to <strong>20% of the sales value</strong> after 40 sales achieved in a month.</li>
          <li>A <strong>credit line of ₹3750.00</strong> is provided to start sales activities.</li>
          <li>Interns will need to sell a minimum of <strong>300 units</strong> aggregating all products during the internship to qualify for lifetime downline commissions or additional incentives.</li>
        </ul>
      </div>

      {/* Referral Program */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">3. Referral Program</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>Participation in the <strong>referral program</strong> allows interns to earn bonuses and commissions.</li>
          <li>Candidates not selected for the internship will still qualify for a <strong>lifetime downline referral bonus (paid monthly)</strong> for customers they and their down the line generate under their network.</li>
        </ul>
      </div>

      {/* Performance Expectations */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">4. Performance Expectations</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>Specific sales targets must be achieved to qualify for the stipend and incentives.</li>
          <li>Interns can utilize their <strong>social network, local contacts, or personal connections</strong> to generate customers.</li>
          <li><strong>No travel or any other expenses</strong> will be reimbursed.</li>
        </ul>
      </div>

      {/* Selection Criteria */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">5. Selection Criteria</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>Applicants must complete a minimum of <strong>5 sales</strong> to qualify for internship selection.</li>
          <li>Final selection will be based on the performance of candidates during this initial sales period, at the discretion of Think5Whys.</li>
        </ul>
      </div>

      {/* Credit Line and Repayment */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">6. Credit Line and Repayment</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>The <strong>₹3750.00 credit line</strong> must be repaid before downline commissions or incentives can be claimed.</li>
          <li>Commissions and bonuses will only be paid after achieving minimum sales of <strong>300 units</strong> and clearing the credit amount.</li>
        </ul>
      </div>

      {/* Additional Conditions */}
      <div>
        <h3 className="text-xl font-semibold text-blue-700 mb-3">7. Additional Conditions</h3>
        <ul className="space-y-2 pl-4 list-disc">
          <li>Think5Whys reserves the right to terminate or disqualify interns for non-compliance with these terms.</li>
          <li>All sales activities must adhere to Think5Whys' ethical guidelines.</li>
          <li>No personal expenses, including travel, will be reimbursed.</li>
          <li>Interns will not hold Think5Whys liable for any kind of losses incurred during the internship.</li>
        </ul>
      </div>

      {/* Footer */}
      <div className="text-sm text-gray-600 text-center mt-8">
        By applying, you agree to these terms. Think5Whys reserves the right to update the terms at any time.
      </div>
    </div>
  );
};

export default InternTnC;
